import {
  abortNavigation,
  defineNuxtRouteMiddleware,
  navigateTo
} from '#app'

// Redirect delle pagine "Opportunità di lavoro" verso la piattaforma esterna
// "Lavora con noi". Il gemello lato server (server/middleware/jobs-redirect.js)
// copre i full page load / bot con un 301 HTTP; questo route middleware copre
// le navigazioni CLIENT-SIDE di Vue Router (link interni in footer/menu), che
// non passano dal server. Gira prima di navigation.global.js (ordine alfabetico).
// Tenere i due elenchi di path allineati.

const DESTINATION = 'https://lavoraconnoi.venetacucine.com/'

const JOBS_PATHS = [
  '/it/opportunita-di-lavoro',
  '/en/job-opportunities',
  '/fr/opportunites-de-carriere',
  '/es/oportunidades-de-trabajo'
]

export default defineNuxtRouteMiddleware(to => {
  const path = (to.path || '').replace(/\/+$/, '').toLowerCase() || '/'

  const isJobs = JOBS_PATHS.some(base => path === base || path.startsWith(`${base}/`))
  if (!isJobs) {
    return
  }

  // Lato client la piattaforma si apre in una NUOVA scheda e l'utente resta
  // sulla pagina corrente; se il popup viene bloccato, fallback stessa scheda.
  if (import.meta.client) {
    const win = window.open(DESTINATION, '_blank', 'noopener')
    if (win) {
      return abortNavigation()
    }
    return navigateTo(DESTINATION, { external: true })
  }

  return navigateTo(DESTINATION, { external: true, redirectCode: 301 })
})
